<section id="wrapper" class="container wrapper-top content-wrapper">
  <article>
    <div class="row">
      <div class="col-xs-12 col-md-6">
        <picture>
          <source media="(min-width: 992px)" srcset="/assets/img/contact/alexander_koenig.png">
          <source media="(min-width: 480px)" srcset="/assets/img/contact/alexander_koenig.png">
          <source media="(min-width: 0px)" srcset="/assets/img/contact/alexander_koenig.png">
          <img class="img-responsive" src="/assets/img/contact/alexander_koenig.png"
               alt="Alexander Koenig">
        </picture>
      </div>
      <div class="col-xs-12 col-md-6">
        <h1 class="headline">Kontakt</h1>
        <h2 class="headline">Kontaktieren Sie mich.</h2>
        <img class="email" src="/assets/svg/email.svg?=v2" alt=""/>
        <app-form></app-form>
      </div>
    </div>
  </article>
</section>
